import { isEditorX } from '../../utils/editorx';
export const defaultSettings = {
  apiUrl: isEditorX ? 'https://files.editorx.com' : 'https://files.wix.com'
};